import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { HttpClient } from '@angular/common/http';
import { AppConfiguration } from 'src/app/app.configuration';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { DevolucionService } from 'src/app/modules/gestionar-venta/services/devolucion.service';
import { FormBuilder, FormGroup } from '@angular/forms';

interface MotivoDevolucion {
  pkid: number;
  nombre: string;
  tipoElemento: string;
  aLaVenta: string;
}

@Component({
  selector: 'ticketing-modal-motivos-devolucion',
  templateUrl: './modal-motivos-devolucion.component.html',
  styleUrls: ['./modal-motivos-devolucion.component.scss']
})
export class ModalMotivosDevolucionComponent implements OnInit, OnDestroy {
  @Input() id: string;
  private element: any;
  
  motivos: MotivoDevolucion[] = [];
  motivoSeleccionado: string = '';
  cargandoMotivos = false;
  esObligatorio = false;
  pulsado = false;
  motivoForm: FormGroup;
  onAceptarCallback: (() => void) | null = null;

  constructor(
    private modalService: ModalService,
    private el: ElementRef,
    private http: HttpClient,
    private config: AppConfiguration,
    private router: Router,
    private toast: ToastrService,
    private devolucionService: DevolucionService,
    private fb: FormBuilder
  ) {
    this.element = el.nativeElement;
    this.motivoForm = this.fb.group({
      motivoSeleccionado: ['']
    });
  }

  ngOnInit() {
    const modal = this;
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }
    document.body.appendChild(this.element);
    this.element.addEventListener('click', function (e: any) {
      if (e.target.className === 'jw-modal') {
        modal.close();
      }
    });
    this.modalService.add(this);
  }

  ngOnDestroy() {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  open(esObligatorio: boolean = false, callback?: () => void) {
    this.esObligatorio = esObligatorio;
    this.motivoSeleccionado = '';
    this.motivoForm.patchValue({ motivoSeleccionado: '' });
    this.pulsado = false;
    this.onAceptarCallback = callback || null;
    
    // Verificar motivos de devolución antes de mostrar el modal
    this.verificarYMostrarModal();
  }

  close() {
    console.log('🔄 [MODAL MOTIVOS] Cerrando modal de motivos de devolución');
    this.pulsado = false;
    this.element.style.display = 'none';
    document.body.classList.remove('jw-modal-open');
  }

  private verificarYMostrarModal() {
    console.log('🔄 [MODAL MOTIVOS] Verificando disponibilidad de motivos de devolución...');
    this.cargandoMotivos = true;
    
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const url = `${this.config.getConfig('API_URL_MS')}/api/Maestros/GetDatosListas?NombreTabla=motivosdevolucion`;
    
    console.log('🔄 [MODAL MOTIVOS] URL de verificación:', url);
    console.log('🔄 [MODAL MOTIVOS] ConexionId:', conexionId);
    
    this.http.get(url).subscribe(
      (response: any) => {
        console.log('✅ [MODAL MOTIVOS] Respuesta de verificación:', response);
        
        if (response && response.datosResult && response.datosResult.datosListas && response.datosResult.datosListas.length > 0) {
          // Hay motivos disponibles, mostrar el modal
          console.log('✅ [MODAL MOTIVOS] Motivos disponibles, mostrando modal');
          this.motivos = response.datosResult.datosListas;
          this.element.style.display = 'block';
          document.body.classList.add('jw-modal-open');
          this.cargandoMotivos = false;
        } else {
          // No hay motivos disponibles, no mostrar modal y ejecutar callback directamente
          console.log('⚠️ [MODAL MOTIVOS] No hay motivos disponibles, ejecutando callback directamente');
          this.motivos = [];
          this.cargandoMotivos = false;
          
          if (this.onAceptarCallback) {
            this.onAceptarCallback();
          }
        }
      },
      (error) => {
        console.error('❌ [MODAL MOTIVOS] Error al verificar motivos:', error);
        
        // En caso de error (incluyendo 204 No Content), no mostrar modal y ejecutar callback directamente
        console.log('🔄 [MODAL MOTIVOS] Error al verificar motivos, ejecutando callback directamente');
        this.motivos = [];
        this.cargandoMotivos = false;
        
        if (this.onAceptarCallback) {
          this.onAceptarCallback();
        }
      }
    );
  }

  private cargarMotivosDevolucion() {
    // Este método ya no se usa, la verificación se hace en verificarYMostrarModal
    // Se mantiene por compatibilidad pero no debería ser llamado
    console.log('⚠️ [MODAL MOTIVOS] cargarMotivosDevolucion() llamado - esto no debería suceder');
  }

  seleccionarMotivo(motivoId: string) {
    console.log('🔄 [MODAL MOTIVOS] Motivo seleccionado:', motivoId);
    this.motivoSeleccionado = motivoId;
    this.motivoForm.patchValue({ motivoSeleccionado: motivoId });
  }

  aceptar() {
    console.log('🔄 [MODAL MOTIVOS] Botón ACEPTAR presionado');
    console.log('🔄 [MODAL MOTIVOS] Es obligatorio:', this.esObligatorio);
    
    const motivoSeleccionado = this.motivoForm.get('motivoSeleccionado')?.value;
    console.log('🔄 [MODAL MOTIVOS] Motivo seleccionado del formulario:', motivoSeleccionado);
    
    // Validar si es obligatorio y no se ha seleccionado motivo
    if (this.esObligatorio && !motivoSeleccionado) {
      console.log('❌ [MODAL MOTIVOS] Motivo obligatorio no seleccionado');
      this.toast.error('Debe seleccionar un motivo', 'Error', {
        toastComponent: ErrorToast,
        timeOut: 5000,
      });
      return;
    }

    this.pulsado = true;
    
    // Almacenar motivo en memoria
    if (motivoSeleccionado) {
      console.log('✅ [MODAL MOTIVOS] Almacenando motivo en memoria:', motivoSeleccionado);
      this.devolucionService.setMotivoDevolucion(motivoSeleccionado);
    } else {
      console.log('✅ [MODAL MOTIVOS] No hay motivo seleccionado, limpiando memoria');
      this.devolucionService.setMotivoDevolucion('');
    }

    // Cerrar modal y ejecutar callback si existe
    this.close();
    console.log('✅ [MODAL MOTIVOS] Modal cerrado, ejecutando callback');
    
    if (this.onAceptarCallback) {
      console.log('🔄 [MODAL MOTIVOS] Ejecutando callback del componente padre');
      this.onAceptarCallback();
    }
  }

  cancelar() {
    console.log('🔄 [MODAL MOTIVOS] Botón CANCELAR presionado');
    this.close();
  }

  isAceptarDisabled() {
    return this.pulsado || this.cargandoMotivos;
  }

  isCancelarDisabled() {
    return this.pulsado;
  }
}
